// Module
var code = "<p>代理投票账户代表你行使投票权力。你可以在<a href=\"https://bitsharestalk.org/index.php/board,75.0.html\">BitSharestalk</a>论坛上找到一些申请成为投票代理人的提案。</p> ";
// Exports
export default code;